export default __webpack_public_path__ + "static/media/logo_main.00510eb9.svg";